<div style="overflow:hidden !important" id="divContainer">
  <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
    <li class="nav-item"><a data-toggle="tab" href="#divUpload" name="upload" class="nav-link active">Main</a></li>
    <li class="nav-item"><a data-toggle="tab" href="#divDashboard" name="main" class="nav-link" (click)="MainGridTable()">Dashboard</a></li>
    <li class="nav-item" id="divReporttab"><a data-toggle="tab" name="report" href="#divReport" class="nav-link">Report</a></li>
    <li class="nav-item"><a data-toggle="tab" name="Config" href="#divConfig" class="nav-link">Config</a></li>
  </ul>
  <div class="tab-content" id="CC3tabContent">

    <div class="tab-pane active" id="divUpload">
      <br />
      <div class="row">
        <div class="col-6">

          <h4 class="hHeading">Discover the language score in 3 steps...</h4>
          <ol>
            <li>
              <h5>Select the formula</h5>
            </li>
            <li>
              <h5>Drag & drop or select the file</h5>
            </li>
            <li>
              <h5>Get the score</h5>
            </li>
          </ol>
          <br /><br /><br />
          <h4 class="hHeading">Parameters</h4>
          <ul>
            <li>
              <h5>Grammar </h5>
            </li>
            <li>
              <h5>Punctuation </h5>
            </li>
            <li>
              <h5>Spelling </h5>
            </li>
            <li>
              <h5>Conventions</h5>
            </li>
            <li>
              <h5>Consistency  </h5>
            </li>
          </ul>

        </div>

        <div class="col-6">
          <button type="button" id="btGetCategory" (click)="CC3ConfigCategoryList()" style="display:none">Get</button>

          <div class="LeftNum" data-text="1">

            <div class="divborder">
              <select id="ddlConfig" class="form-control" onchange="$('#btGetCategory').trigger('click');">
                <option value=0 selected>Select the formula</option>
                <option *ngFor="let item of configList" value={{item.Id}}>
                  {{item.FormulaName}}
                </option>
              </select>
            </div>


            <div id="divConfigDetails" class="col" style="overflow: hidden; overflow-y: auto;">

            </div>

          </div>

          <br />

          <div class="LeftNum" data-text="2">

            <div draggable="true" ngClass="{{dragAreaClass}}">
              <div class="row">
                <div class="col-md-12 text-center">
                  <i class="fa fa-upload"></i>
                  Drag files here
                  <a href="javascript:void(0)" (click)="file.click()">
                    or click to open
                  </a>
                  <input type="file"
                         #file
                         [multiple]="false"
                         (change)="onFileChange($event)"
                         style="display:none" id="file_cc3upload" />
                </div>
                <div class="error" *ngIf="error">
                  Only one file at time allow
                </div>
              </div>
            </div>

          </div>



          <div class="LeftNum" data-text="3">

            <button type="button" id="btGetArticleSummaryLog" (click)="GetArticleSummaryLog()" style="display:none">Get</button>
            <div class="row">
              <div class="card-title">Language score</div>
            </div>
            <hr />

            <div class="col-sm-12" id="divCC3ArticleLog" style="overflow: hidden; overflow-y: auto;">
              <div class="col" *ngFor="let item of CC3articleSummaryLog">
                <div class="row" style="white-space:nowrap;padding:5px">
                  <div class="col-sm-6">
                    <strong class="mb-1">{{item.ArticleNo}}</strong>
                    <div>File : {{item.UploadedFile}}</div>
                    <div>Start Date : {{GetDateFormatValue(item.StartDate)}}</div>
                    <div>Completed Date : {{GetDateFormatValue(item.CompletedDate)}}</div>
                    <div>No Of Pages : {{item.NoOfPages}}</div>
                    <div>Status : {{item.CurrentStatus}}</div>
                    <div>Remarks : {{item.Remarks}}</div>
                    <h5>Formula : {{item.FormulaName}}</h5>
                  </div>
                  <div class="col-sm-6" style="text-align:right;">
                    <i class="fa fa-times iIcon DelFront" style="float:right" title="Remove"
                       (click)="RemoveEntery(item.Id)" *ngIf="item.CurrentStatus != 'Work in Process'"></i>
                    <br />
                    <h5 class="small-box-footer spFilter" *ngIf="item.CC3Grade!=null && item.CC3Score!=null">
                      <strong>{{item.CC3Grade}} / {{item.CC3Score}}</strong>
                    </h5>
                    <div class="small-box-footer spFilter" *ngFor="let itemT of CC3articleSummaryLogTrans">
                      <div *ngIf="item.Id == itemT.Id && itemT.Category !=null">
                        <strong>{{itemT.Category}} : {{itemT.CategoryValue}}</strong>
                      </div>
                    </div>

                  </div>
                </div>
                <hr />
              </div>
            </div>

            <!--<div id="divCC3ArticleLog" style="overflow: hidden; overflow-y: auto;">

            </div>-->

          </div>

        </div>
      </div>
    </div>

    <div class="tab-pane" id="divDashboard">

      <div class="form-group">

        <div class="row" id="divSummaryIndex">


          <div class="col-12 col-sm-7 col-md-3">
            <div class="info-box">
              <span class="info-box-icon bg-blue elevation"><i class="fa fa-check-double"></i></span>
              <div class="info-box-content">
                <span class="info-box-text" style="font-weight: 600; font-size: 1.5em;">All</span><hr />
                <span class="info-box-number" style="font-size:1.5em;">{{cc3ALLlist}}</span>
                <button type="button" class="btn btn-sm btn-outline-info p-2 ml-5 mr-2" (click)="MainGridTable(null)">View List</button>
              </div>
            </div>
          </div>


          <div class="col-12 col-sm-8 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-secondary elevation-1"><i class="fas fa-clock"></i></span>
              <div class="info-box-content">
                <span class="info-box-text" style="font-weight: 600; font-size: 1.5em">YTS</span><hr />
                <span class="info-box-number" style="font-size:1.5em;">{{cc3YTSlist}}</span>
                <button type="button" class="btn btn-sm btn-outline-secondary p-2 ml-5 mr-2" (click)="MainGridTable(0)">View List</button>
              </div>
            </div>
          </div>


          <div class="col-12 col-sm-7 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-spinner"></i></span>
              <div class="info-box-content">
                <span class="info-box-text" style="font-weight: 600; font-size: 1.5em;">WIP</span><hr />
                <span class="info-box-number" style="font-size:1.5em;">{{cc3WIPlist}}</span>
                <button type="button" class="btn btn-sm btn-outline-warning  p-2 ml-5 mr-2" (click)="MainGridTable(1)">View List</button>
              </div>
            </div>
          </div>


          <div class="col-12 col-sm-7 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-success elevation-1"><i class="fas fa-check"></i></span>
              <div class="info-box-content">
                <span class="info-box-text" style="font-weight: 600; font-size: 1.5em;">Completed</span><hr />
                <span class="info-box-number" style="font-size:1.5em;">{{cc3Copmletedlist}}</span>
                <button type="button" class="btn btn-sm btn-outline-success p-2 ml-5 mr-2" (click)="MainGridTable(2)">View List</button>

              </div>
            </div>
          </div>


        </div>

        <button type="button" id="btnLoadList" (click)="MainGridTable(null)" style="display:none">Get</button>
        <button type="button" (click)="PopupShowCC3List()" id="btnUploadFile" style="display:none">Add</button>
        <button type="button" id="btnDocUpload" (click)="UploadFile()" style="display:none;">Upload Doc</button>

      </div>

      <table #dataTable class="display" style="width:100%"></table>


      <!--Add Popup Start-->
      <div class="modal" id="myModalCC3List" style="position: fixed !important;display:none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header" style="text-align:center">
              <h4 class="modal-title">Add Info</h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideCC3List()">&times;</button>
            </div>
            <!--popupbody-->
            <div class="modal-body" id="popupbody">
              <div class="form-group">
                <button type="button" id="btnJrlList" (click)="GetJournalsdetails()" style="display:none">Get</button>
                <button type="button" id="btnArticleList" (click)="GetArticleList()" style="display:none">Get</button>
                <div class="row">
                  <div class="col-sm-6">
                    <label for="ddlPublisher">Publisher</label><em>*</em>
                    <select id="ddlPublisher" class="form-control" onchange="$('#btnJrlList').trigger('click');">
                      <option value=0>Select</option>
                      <option *ngFor="let item of PublisherList" value={{item.ID}}>
                        {{item.PublisherCode}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    <label for="ddlJournalList">Journal</label><em>*</em>
                    <select id="ddlJournalList" class="form-control" onchange="$('#btnArticleList').trigger('click');">
                      <option value=0>Select</option>
                      <option *ngFor="let item of journalList" value={{item.ID}}>
                        {{item.Acronym}}
                      </option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-sm-6">
                    <label for="ddlArticleNo">Article No</label><em>*</em>
                    <select id="ddlArticleNo" class="form-control ddlselect">
                      <option *ngFor="let item of artcileList" [selected]="item.ID == articleId" value={{item.ArticleNo}}>
                        {{item.ArticleNo}}
                      </option>
                    </select>
                  </div>

                  <div class="col-sm-6">
                    <label for="ddlArticleTypeList">Article Type</label><em>*</em>
                    <select id="ddlArticleTypeList" class="form-control">
                      <option *ngFor="let item of ArticleTypeList" value={{item.SNo}}>
                        {{item.TypeName}}
                      </option>
                    </select>
                  </div>

                  <div class="col-sm-12 clsMargin">
                    <div class="UploadFile">
                      <input #fileInput type="file" (change)="onuploadSelected($event)" id="doc_uploadfile" />
                    </div><br />
                    <label>Upload file should be  <span style="color: red;">doc,docx</span> format.</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCC3List()">Close</button>
                <button type="submit" (click)="CC3List()" class="btn btn-outline-success waves-effect waves-light">{{CC3ModalButton}}</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
            </div>
          </div>
        </div>
      </div>
      <!--Add Popup end-->

      <button type="button" id="btnPopupDT" (click)="CC3ArticleSummaryLogic()" style="display:none;">Show</button>

      <!--Summary Calculation-->
      <div class="modal" id="myModalCal" [style.display]="showSummaryCalModal ? 'block' : 'none'">
        <div class="modal-dialog">
          <div class="modal-content" id="divStatusCT">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title" id="divSummaryLogicTitle">Summary Log</h4>
              <button type="button" class="close" data-dismiss="modal" (click)="HideSummaryCal()">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <div id="divSummaryLogic">
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>

        </div>

      </div>


    </div>

    <div class="tab-pane" id="divReport">
      <button type="button" id="btnJrlRepList" (click)="GetJournalsdetailsReport()" style="display:none">Get</button>
      <div class="row" id="divReportTabPanel">
        <div class="col-sm-2">
          <label for="ddlPublisherReport">Publisher</label>
          <select id="ddlPublisherReport" class="form-control" onchange="$('#btnJrlRepList').trigger('click');">
            <option value=0>Select</option>
            <option *ngFor="let item of PublisherList" value={{item.ID}}>
              {{item.PublisherCode}}
            </option>
          </select>
        </div>
        <div class="col-sm-2">
          <label for="ddlJournalListReport">Journal</label>
          <select id="ddlJournalListReport" class="form-control">
            <option value=0>Select</option>
            <option *ngFor="let item of journalListReport" value={{item.ID}}>
              {{item.Acronym}}
            </option>
          </select>
        </div>
        <div class="col-sm" name="ReceivedDate">
          <div class="form-group">
            <label for="txtFromDt">From Date<em>*</em></label>
            <input type="date" class="form-control" id="txtFromDt">
          </div>
        </div>
        <div class="col-sm" name="ReceivedDate">
          <div class="form-group">
            <label for="txtToDt">To Date<em>*</em></label>
            <input type="date" class="form-control" id="txtToDt">
          </div>
        </div>
        <div class="col-sm-4">

          <button type="button" id="getFilterReport" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFilteredReport()">Search</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
        </div>
      </div>

      <button type="button" id="btnLoadList" style="display:none">Get</button>


      <table #dataTableSr class="display" style="width:100%"></table>

    </div>



    <div class="tab-pane" id="divConfig">
      <app-cc3-config></app-cc3-config>
    </div>


  </div>

</div>






